module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/okinawa-91034f960f6db66d392d2dcd0c5f7683.jpg";